const value = {
    turnIntoQuestion: 'Превратить в вопрос',
    removeQuestion: 'Убрать вопрос',
    rename: 'Переименовать',
  };

export default value;
